import { render, staticRenderFns } from "./productcard.vue?vue&type=template&id=7967348c&scoped=true"
import script from "./productcard.vue?vue&type=script&lang=js"
export * from "./productcard.vue?vue&type=script&lang=js"
import style0 from "./productcard.vue?vue&type=style&index=0&id=7967348c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7967348c",
  null
  
)

export default component.exports